var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStacklineLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3415 597.8",
    style: {
      enableBackground: "new 0 0 3415 597.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "on_black"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.4,594.5c-51-0.1-92.3-41.4-92.4-92.4v-82.6h101v59c0,12.7,10.3,23,23,23l0,0h160c12.7,0,23-10.3,23-23l0,0 v-72.3c0-24.1-11.2-30.9-34.7-36.3l-156-33.6c-39.5-8.5-66.3-20-84.3-36.2C11.8,282,2,256.9,2,223.4V115.9 c0.1-51,41.4-92.3,92.4-92.4h215.2c51,0.1,92.3,41.4,92.4,92.4v75.6H301v-52c0-12.7-10.3-23-23-23l0,0H130c-12.7,0-23,10.3-23,23 l0,0V205c0,24.1,11.2,30.9,34.7,36.3l156,33.6c39.5,8.5,66.3,20,84.3,36.2c20.2,18.1,30,43.2,30,76.7v114.3 c-0.1,51-41.4,92.3-92.4,92.4H92.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617,594.5c-46.4-0.1-83.9-37.6-84-84v-275h-67v-78h69V71.1l96-20.7v107.1h99v78h-97V492 c0,12.4,10.1,22.5,22.5,22.5H730v80H617z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M910.9,597.8c-42.5,0-70.4-8.7-87.9-27.3c-17.7-18.8-26-48.9-26-94.8c0-43.3,9.6-74.5,29.3-95.5 c17.5-18.6,43.4-30,81.6-35.9c41.5-6.4,84.8-9.7,145.5-13.3l7.5-0.4v-71.7c0-12.4-10.1-22.5-22.5-22.5h-105 c-12.4,0-22.5,10.1-22.5,22.5v22.5h-98v-40c0.1-46.4,37.6-83.9,84-84h180c46.4,0.1,83.9,37.6,84,84v353h-100v-87.6l-14.5,20.5 c-19.2,27.1-35.6,43.2-55,53.8C970.7,592.6,945.1,597.8,910.9,597.8z M1052.2,391.5c-48.4,5.1-97.6,14.1-121.1,20.4 c-24.4,6.5-35.3,15.6-35.3,52.2c0,18.2,1.2,31.2,7.1,39.5c6.6,9.3,17.2,11.2,31,11.2c55.6,0,86.7-16.7,119.6-34.4l7.5-4v-85.9 L1052.2,391.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1343,594.5c-46.4-0.1-83.9-37.6-84-84v-269c0.1-46.4,37.6-83.9,84-84h180c46.4,0.1,83.9,37.6,84,84v66h-100 V265c0-12.4-10.1-22.5-22.5-22.5h-103c-12.4,0-22.5,10.1-22.5,22.5v223c0,12.4,10.1,22.5,22.5,22.5h103c12.4,0,22.5-10.1,22.5-22.5 v-43.5h100v66c-0.1,46.4-37.6,83.9-84,84H1343z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1978.2,594.5 1877.1,400.8 1804,492.3 1804,594.5 1706,594.5 1706,21.1 1804,0 1804,367.3 1963,157.5  2072.8,157.5 1939.1,323.9 2084.5,594.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2149,594.5 2149,21.8 2249,0.3 2249,594.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2371,594.5v-437h100v437H2371z M2368,91.5V23.3l106-22.9v91.1H2368z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2858,594.5V271.3c0-25.1-13.1-29.8-37.3-29.8c-44.8,0-86.4,12-124,35.5l-3.7,2.3v315.2h-100v-437h100v84.1 l14.6-21.1c34.7-50.1,69-67,136-67c41.9,0,71,8.1,88.8,24.8c17.5,16.4,25.7,41.7,25.7,79.6v336.6H2858z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3140,594.5c-46.4-0.1-83.9-37.6-84-84v-269c0.1-46.4,37.6-83.9,84-84h191c46.4,0.1,83.9,37.6,84,84v159h-259 V494c0,12.4,10.1,22.5,22.5,22.5h114c12.4,0,22.5-10.1,22.5-22.5v-31.5h100v48c-0.1,46.4-37.6,83.9-84,84H3140z M3178.5,235.5 c-12.4,0-22.5,10.1-22.5,22.5v80.5h159V258c0-12.4-10.1-22.5-22.5-22.5H3178.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacklineLogo);
export default __webpack_public_path__ + "static/media/stackline_logo.5935081bd899ecfe02395699e768f84e.svg";
export { ForwardRef as ReactComponent };